export const MeetingState_Both_BothNoShow = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/both/bothNoShow.html';
    },
];
